




































































































	import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
	import { Action } from 'vuex-class';

	/**
	 * Composant de représentation d'un item sous forme d'élément d'une liste.
	 */
	@Component
	export default class ShopItemListElement extends Vue {
		/** Propriétés */
		// Un item
		@Prop()
		item!: any;

		@Prop()
		handleItemAddClick!: (itemId: number) => Promise<void>;

		@Prop()
		handleItemRemoveClick!: (itemId: number,formulaNum: number|null) => Promise<void>;


		@Prop()
		subItem! : any;

		/** Attributs */
		isActionLoading: boolean = false;

		/** Méthodes */
		async onItemAddClick(itemId: number) {
			this.isActionLoading = true;
			try {
				await this.handleItemAddClick(itemId);
				this.isActionLoading = false;
			}
			catch (error) {
				this.isActionLoading = false;
				throw error;
			}
		}
		async onItemRemoveClick(itemId: number,formulaNum: number | null) {
		
			this.isActionLoading = true;
			try {
				await this.handleItemRemoveClick(itemId,formulaNum);
				this.isActionLoading = false;
			}
			catch (error) {
				this.isActionLoading = false;
				throw error;
			}
		}

	formatPrice(value:any) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

	}
